import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

const BREAKPOINT = 576; // coincide con el breakpoint PHP donde enabled: false

/**
 * Pinea la sección .layout-our-team cuando el .swiper-parent llega al viewport,
 * convierte el scroll vertical en desplazamiento horizontal del .swiper-wrapper
 * y libera el scroll al terminar (reverse incluido).
 *
 * >= BREAKPOINT : GSAP activo, Swiper desactivado (via PHP enabled: false).
 * <  BREAKPOINT : Swiper nativo, GSAP no se instancia.
 *
 * ScrollTrigger.matchMedia gestiona el ciclo de vida internamente,
 * evitando saltos de scroll al cambiar de breakpoint.
 * onResizeEnd recalcula medidas cuando el layout se estabiliza.
 */
export function initOurTeamScroll() {
  const section = document.querySelector( '.layout-our-team' );
  if ( !section ) return;

  const swiperParent = section.querySelector( '.swiper-parent' );
  if ( !swiperParent ) return;

  const wrapper = section.querySelector( '.swiper-wrapper' );
  if ( !wrapper ) return;

  ScrollTrigger.matchMedia( {

    // ── Desktop: GSAP activo ────────────────────────────────────────────────
    [ `(min-width: ${ BREAKPOINT }px)` ]: function() {
      gsap.set( wrapper, {
        display   : 'flex',
        flexWrap  : 'nowrap',
        overflowX : 'hidden',
        willChange: 'transform',
      } );

      const proxy = { x: 0 };

      const getMaxScroll = () => wrapper.scrollWidth - wrapper.clientWidth;

      const tween = gsap.to( proxy, {
        x       : () => getMaxScroll(),
        ease    : 'none',
        onUpdate: () => {
          wrapper.scrollLeft = proxy.x;
        },
      } );

      ScrollTrigger.create( {
        trigger            : swiperParent,
        start              : 'top top',
        end                : () => `+=${ getMaxScroll() }`,
        pin                : section,
        anticipatePin      : 1,
        scrub              : 1,
        invalidateOnRefresh: true,
        animation          : tween,
        markers            : false,
        onLeaveBack        : () => {
          gsap.set( proxy, { x: 0 } );
          wrapper.scrollLeft = 0;
        },
      } );

      // Cleanup que ejecuta matchMedia al salir de este breakpoint
      return () => {
        gsap.set( wrapper, { clearProps: 'all' } );
        wrapper.scrollLeft = 0;
      };
    },

  } );

  // ── onResizeEnd: recalcular medidas cuando el layout se estabiliza ────────
  // invalidateOnRefresh recalcula los valores internos del tween,
  // ScrollTrigger.refresh() recalcula posiciones y dimensiones del pin.
  window.addEventListener( 'onResizeEnd', () => {
    if ( window.innerWidth >= BREAKPOINT ) ScrollTrigger.refresh();
  } );
}
